<ng-template #itemContent>
  <div class="card-header">
    <div class="header-top">
      <h3 [title]="template.name">{{ template.name }}</h3>
    </div>
    @if (template.is_latest) {
      <span class="version-badge">Latest</span>
    }
  </div>

  <div class="btn-holder">
    @if (template.s3_key) {
      <button mat-icon-button (click)="downloadTemplate($event)" class="download-btn" matTooltip="Download">
        <mat-icon>download</mat-icon>
      </button>

      <button mat-icon-button (click)="openPreview(template, $event)" class="download-btn" matTooltip="Preview">
        <mat-icon>preview</mat-icon>
      </button>
    }
    <button mat-icon-button (click)="uploadFile(template, $event)" class="download-btn" matTooltip="Upload file">
      <mat-icon>upload</mat-icon>
    </button>
    <p class="version-info">Version: {{ template.version }}</p>
  </div>
</ng-template>
@if (isLink) {
  <a class="template-card" [routerLink]="template.id">
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>
} @else {
  <button type="button" class="template-card" (click)="openDetails(template, $event)">
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </button>
}
